
import { getListAlbum, listMusicForAlbum, createAlbum, updateAlbum, getDetailAlbum,
  publishAlbum, unpublishAlbum, deleteAlbum, getListAlbumByArtist, countSubmissionContent,
  approvalAlbum, getTagsAlbum, saveTagsAlbum, createAlbumAdmin, editAlbumAdmin, createAlbumAdminStream, editAlbumAdminStream, addSubmitSubmissionProcess } from '@/services/album';

const getters = {
  listAlbum: state => state.listAlbum,
  listAlbumArtist: state => state.listAlbumArtist,
  totalAlbum: state => state.totalAlbum,
  listSong: state => state.listSong,
  totalSong: state => state.totalSong,
  countWaitingForReviewAlbum: state => state.countWaitingForReviewAlbum,
  countUnderReviewAlbum: state => state.countUnderReviewAlbum,
  countApprovedAlbum: state => state.countApprovedAlbum,
  countRejectedAlbum: state => state.countRejectedAlbum,
  countPublishedAlbum: state => state.countPublishedAlbum,
  countWaitingForReviewAlbumArtist: state => state.countWaitingForReviewAlbumArtist,
  countUnderReviewAlbumArtist: state => state.countUnderReviewAlbumArtist,
  countApprovedAlbumArtist: state => state.countApprovedAlbumArtist,
  countRejectedAlbumArtist: state => state.countRejectedAlbumArtist,
  countPublishedAlbumArtist: state => state.countPublishedAlbumArtist,
};

const actions = {
  async requestListAlbum({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const filterList = filter.status === 4 ? { ...filter, status: 2, published: 1 } : { ...filter, published: 0 };
      const result = await getListAlbum(filterList, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
      commit('SET_LIST_ALBUM', result.data);
      if (!isArtist) {
        dispatch('requestCountStatusAlbum');
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailAlbum({ commit, rootGetters }, idAlbum) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let result;
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      result = await getDetailAlbum(idAlbum, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return result.data;
  },
  async requestListSongForAlbum({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const result = await listMusicForAlbum(filter, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_SONG', result);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateAlbum({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-create-album' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateAlbumAdmin({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createAlbumAdmin(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateAlbumAdminStream({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createAlbumAdminStream(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-create-album' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateAlbum({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await updateAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-edit-album' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditAlbumAdmin({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editAlbumAdmin(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditAlbumAdminStream({ commit, dispatch, rootGetters }, album) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editAlbumAdmin(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-edit-album' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPublishAlbum({ commit, dispatch, rootGetters }, { album, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await publishAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListAlbum', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUnpublishAlbum({ commit, dispatch, rootGetters }, { album, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await unpublishAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListAlbum', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteAlbum({ commit, dispatch, rootGetters }, { album, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      await deleteAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
      dispatch('requestListAlbum', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListAlbumByArtist({ commit, dispatch, rootGetters }, { filter, data }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const filterList = filter.status === 4 ? { ...filter, status: 2, published: 1 } : { ...filter, published: 0 };
      const result = await getListAlbumByArtist(filterList, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      commit('SET_LIST_ALBUM_BY_ARTIST', result.data);
      dispatch('requestStatusSubmissionByArtist', data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCountStatusAlbum({ commit, rootGetters }) {
    try {
      const countWaitingForReview = await countSubmissionContent(0, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countUnderReview = await countSubmissionContent(1, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countApproved = await countSubmissionContent(2, 0, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countRejected = await countSubmissionContent(3, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countPublished = await countSubmissionContent(2, 1, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('UPDATE_COUNT_STATUS', { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestStatusSubmissionByArtist({ commit, rootGetters }, data) {
    try {
      const countWaitingForReview = await countSubmissionContent(0, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countUnderReview = await countSubmissionContent(1, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countApproved = await countSubmissionContent(2, 0, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countRejected = await countSubmissionContent(3, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countPublished = await countSubmissionContent(2, 1, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      commit('UPDATE_COUNT_STATUS_BY_ARTIST', { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished });
    } catch (err) {
      console.log(err);
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestApprovalAlbum({ commit, dispatch, rootGetters }, { album, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await approvalAlbum(album, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListAlbum', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetTagsAlbum({ rootGetters }, filter) {
    let response = [];
    try {
      const result = await getTagsAlbum(filter, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      response = result.data;
    } catch (err) {

    }
    return response;
  },
  async requestSaveTagsAlbum({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await saveTagsAlbum(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListAlbum', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSubmitSubmissionProcessAlbum({ commit, dispatch, rootGetters }, { submissionData, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      await addSubmitSubmissionProcess(submissionData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListAlbum', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_ALBUM(state, listAlbum) {
    state.listAlbum = listAlbum.data;
    state.totalAlbum = listAlbum.total;
  },
  SET_LIST_ALBUM_BY_ARTIST(state, listAlbum) {
    state.listAlbumArtist = listAlbum;
  },
  SET_LIST_SONG(state, listSong) {
    state.listSong = listSong.data;
    state.totalSong = listSong.total;
  },
  UPDATE_COUNT_STATUS(state, { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished }) {
    state.countWaitingForReviewAlbum = countWaitingForReview.data.total;
    state.countUnderReviewAlbum = countUnderReview.data.total;
    state.countApprovedAlbum = countApproved.data.total;
    state.countRejectedAlbum = countRejected.data.total;
    state.countPublishedAlbum = countPublished.data.total;
  },
  UPDATE_COUNT_STATUS_BY_ARTIST(state, { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished }) {
    state.countWaitingForReviewAlbumArtist = countWaitingForReview.data.total;
    state.countUnderReviewAlbumArtist = countUnderReview.data.total;
    state.countApprovedAlbumArtist = countApproved.data.total;
    state.countRejectedAlbumArtist = countRejected.data.total;
    state.countPublishedAlbumArtist = countPublished.data.total;
  },
};

export default {
  namespaced: true,
  state: {
    listAlbum: [],
    listAlbumArtist: [],
    listSong: [],
    totalAlbum: 0,
    totalSong: 0,
    countWaitingForReviewAlbum: 0,
    countUnderReviewAlbum: 0,
    countApprovedAlbum: 0,
    countRejectedAlbum: 0,
    countPublishedAlbum: 0,
    countWaitingForReviewAlbumArtist: 0,
    countUnderReviewAlbumArtist: 0,
    countApprovedAlbumArtist: 0,
    countRejectedAlbumArtist: 0,
    countPublishedAlbumArtist: 0,
  },
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/stores/Album/index.js